import { render, staticRenderFns } from "./PageNewDroneAssessment.vue?vue&type=template&id=25ad7e8e&scoped=true&"
import script from "./PageNewDroneAssessment.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PageNewDroneAssessment.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ad7e8e",
  null
  
)

export default component.exports